module.exports = __webpack_public_path__ + "static/device-screens-1075e336d439955005f910ffd606fe97.jpg";